import axios from 'axios'

export function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64)
  var binaryLen = binaryString.length
  var bytes = new Uint8Array(binaryLen)
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}

//check for native saveAs function
const saveAs = (window.saveAs || window.webkitSaveAs || window.mozSaveAs || window.msSaveAs ||
  //(msIE) save Blob API
  (!window.navigator.msSaveOrOpenBlob ? false : function(blobData, fileName) {
    return window.navigator.msSaveOrOpenBlob(blobData, fileName)
  }) ||
  //save blob via a href and download
  (!window.URL ? false : function(blobData, fileName) {
    //create blobURL
    var blobURL = window.URL.createObjectURL(blobData),
      deleteBlobURL = function() {
        setTimeout(function() {
          //delay deleting, otherwise firefox wont download anything
          window.URL.revokeObjectURL(blobURL)
        }, 250)
      }

    //test for download link support
    if ('download' in document.createElement('a')) {
      //create anchor
      var a = document.createElement('a')
      //set attributes
      a.setAttribute('href', blobURL)
      a.setAttribute('download', fileName)
      //create click event
      a.onclick = deleteBlobURL

      //append, trigger click event to simulate download, remove
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } else {
      //fallback, open resource in new tab
      window.open(blobURL, '_blank', '')
      deleteBlobURL()
    }
  }))

export function downloadFileBytes(filename, bytes) {
  let dataArray = base64ToArrayBuffer(bytes)
  let blob = new Blob([dataArray])
  saveAs(blob, filename)
  // saveByteArray(filename, dataArray)
}

export async function download(url, fileName, params) {
  fileName = fileName || 'file.xlsx'

  let response = await axios({
    url: url,
    method: 'GET',
    responseType: 'blob', // important
    params,
  })

  if (response.status == 204) {
    throw response
  }

  if (window.navigator && window.navigator.msSaveOrOpenBlob) { //for IE
    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
  } else {
    const bloburl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = bloburl
    link.setAttribute('download', fileName) //or any other extension
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export function downloadByPost(url, requestData, fileName, options) {
  fileName = fileName == null ? 'file.xlsx' : fileName
  var params = (options == null || options.params == null) ? {} : options.params
  axios({
    url: url,
    method: 'POST',
    data: requestData,
    responseType: 'blob', // important
    params: params,
  }).then((response) => {
    if (response.data.type == 'application/json') {
      options.nodataCb(response)
    } else {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) { //for IE
        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
      } else {
        const bloburl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = bloburl
        link.setAttribute('download', fileName) //or any other extension
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      if (options) {
        options.successful()
      }
    }
  }).catch((error) => {
    if (options && options.failedCb) {
      options.failedCb(error)
    }
  })
}

export function downloadFileResults(fileResults) {
  fileResults.forEach(({
    fileName,
    data,
  }) => { downloadFileBytes(fileName, data) })
}